import React, { useEffect } from 'react'
import {
    Create,
    Edit,
    FormDataConsumer,
    RadioButtonGroupInput,
    required,
    SelectInput,
    SimpleForm,
    TextInput
} from 'react-admin'
import { useLocation } from 'react-router-dom'
import api from '../../../Services/Api'

export const ProductCoveragesEdit = (props) => {
    const [coverageOptions, setCoverageOptions] = React.useState([])

    useEffect(() => {
        ;(async () => {
            try {
                const result = await api.get(
                    `admin/coverages?_order=ASC&_sort=name`
                )
                setCoverageOptions(result.data)
            } catch (error) {
                console.log('Erro ao consultar coberturas', error)
            }
        })()
    }, [])

    const redirect = (basePath, id, data) => {
        return `/admin/products/${data.productId}/show/2`
    }

    return (
        <Edit {...props} mutationMode="pessimistic">
            <SimpleForm redirect={redirect}>
                <SelectInput
                    label="Cobertura"
                    source="coverageId"
                    choices={coverageOptions}
                    resettable
                    validate={[required()]}
                />
                <TextInput
                    label="Descrição Adicional"
                    source="additionalDescription"
                />
                <RadioButtonGroupInput
                    label="Tipo"
                    source="valueType"
                    helperText={false}
                    choices={[
                        { id: 1, name: 'Valor' },
                        { id: 2, name: 'Sim' },
                        { id: 3, name: 'Não' },
                        { id: 4, name: 'Descrição' },
                    ]}
                />
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.valueType === 1 && (
                            <TextInput label="Valor" source="value" {...rest} />
                        )
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.valueType === 4 && (
                            <TextInput
                                label="Descrição"
                                source="valueDescription"
                                {...rest}
                            />
                        )
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.valueType === 1 && (
                            <TextInput
                                label="Moeda"
                                source="currency"
                                validate={[required()]}
                            />
                        )
                    }
                </FormDataConsumer>
            </SimpleForm>
        </Edit>
    )
}

export const ProductCoveragesCreate = (props) => {
    const [coverageOptions, setCoverageOptions] = React.useState([])

    useEffect(() => {
        ;(async () => {
            try {
                const result = await api.get(
                    `admin/coverages?_order=ASC&_sort=name`
                )
                setCoverageOptions(result.data)
            } catch (error) {
                console.log('Erro ao consultar coberturas', error)
            }
        })()
    }, [])

    const location = useLocation()
    const redirect = (basePath, id, data) =>
        `/admin/products/${data.productId}/show/2`
    const transform = (data) => ({
        ...data,
        productId: location.state.productId,
    })

    return (
        <Create {...props} mutationMode="pessimistic" transform={transform}>
            <SimpleForm redirect={redirect}>
                <SelectInput
                    label="Cobertura"
                    source="coverageId"
                    choices={coverageOptions}
                    resettable
                    validate={[required()]}
                />
                <TextInput
                    label="Descrição Adicional"
                    source="additionalDescription"
                />
                <RadioButtonGroupInput
                    label="Tipo"
                    source="valueType"
                    helperText={false}
                    choices={[
                        { id: 1, name: 'Valor' },
                        { id: 2, name: 'Sim' },
                        { id: 3, name: 'Não' },
                        { id: 4, name: 'Descrição' },
                    ]}
                />
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.valueType === 1 && (
                            <TextInput label="Valor" source="value" {...rest} />
                        )
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.valueType === 4 && (
                            <TextInput
                                label="Descrição"
                                source="valueDescription"
                                {...rest}
                            />
                        )
                    }
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, ...rest }) =>
                        formData.valueType === 1 && (
                            <TextInput
                                label="Moeda"
                                source="currency"
                                validate={[required()]}
                            />
                        )
                    }
                </FormDataConsumer>
            </SimpleForm>
        </Create>
    )
}
